import { takeEvery } from 'redux-saga/effects';
import { call, put } from 'redux-saga/effects';
import { getDashboardDataApi, getUserProjectManagerWorkerDataApi } from "../api";
import { getDashboardOverviewDataFailure, getDashboardOverviewDataSuccess, getUserProjectManagerWorkerDataFailure, getUserProjectManagerWorkerDataSuccess } from '../actions/dashboardAction';
import { GET_DASHBOARD_OVERVIEW_DATA, GET_USER_PROJECT_MANAGER_WORKER_DATA } from '../storeTypes';


function* getDashboardData({ payload }) {
    try {
        const response = yield call(getDashboardDataApi, payload);
        yield put(getDashboardOverviewDataSuccess(response.data.data))
    } catch (error) {
        yield put(getDashboardOverviewDataFailure(error))
    }
}

function* getUserProjectManagerWorkerData({ payload }) {
    const { url, chartKey } = payload;
    try {
        const response = yield call(getUserProjectManagerWorkerDataApi, url);
        yield put(getUserProjectManagerWorkerDataSuccess({ ...response.data.data, chartKey }))
    } catch (error) {
        yield put(getUserProjectManagerWorkerDataFailure({ error, chartKey }))
    }
}


export function* dashboardSage() {
    return [
        yield takeEvery(GET_DASHBOARD_OVERVIEW_DATA, getDashboardData),
        yield takeEvery(GET_USER_PROJECT_MANAGER_WORKER_DATA, getUserProjectManagerWorkerData),
    ]
}